module.exports = __webpack_public_path__ + "static/media/IPRMainPage.8671e444.PNG";